import accessibilityAriaEnum from "../enums/accessibilityAriaEnum";

export const getAllParams = (params) => {
    const newParams = { ...params };

    if (params.testId) {
        newParams['data-testid'] = params.testId;
        delete newParams.testId;
    }
    else if (params.hasOwnProperty('testId')) {
        delete newParams.testId;
    }

    Object.keys(accessibilityAriaEnum).forEach(key => {
        if (params[key]) {
            newParams[accessibilityAriaEnum[key]] = params[key];
            delete newParams[key];
        }
        else if (params.hasOwnProperty(key)) {
            delete newParams[key];
        }
    });

    return newParams;
};
